import { action, makeAutoObservable } from "mobx";
class Store {
  showModal = true;
  groupVisible = true;
  aid = '';
  constructor() {
    makeAutoObservable(this);
  }
  updateShowModal(val) {
    this.showModal = val;
  }
  @action updateGroupVisible(val) {
    this.groupVisible = val;
  }
  setAid(value) {
    this.aid = value
  }
}
const store = new Store();
export default store;
